import { getProfileImage } from "@shared/hooks/useProfile";
import { UserProfile } from "@shared/types/user";
import React from "react";
import { Link } from "react-router-dom";
import theme from "@shared/utils/themeColors";

interface AuthorStats {
  karma: number;
  posts: number;
  comments: number;
}

interface AuthorInfoProps {
  author: UserProfile;
  stats: AuthorStats;
}

/**
 * Component that displays author information with stats
 */
const AuthorInfo: React.FC<AuthorInfoProps> = ({ author, stats }) => {
  return (
    <div className={`${theme.bg.primary} p-4 rounded-xl mb-4`}>
      <div className={`text-xs font-semibold ${theme.text.inactive} uppercase mb-4`}>
        About The Author
      </div>

      <div className="flex items-center mb-4">
        <Link to={`/community/profile/${author.id}`}>
          <img
            className="w-10 h-10 rounded-full mr-4"
            src={getProfileImage(author)}
            alt={author.name}
          />
        </Link>
        <div className="flex flex-col gap-0">
          <Link
            to={`/community/profile/${author.id}`}
            className={`text-md font-bold ${theme.text.primary} hover:text-gray-900 dark:hover:text-white`}
          >
            {author.name}
          </Link>
          <div className={`${theme.text.muted} text-sm`}>
            {author.title || author.role || ""}
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <div className="flex items-center">
          <span className="text-xl mr-2" role="img" aria-label="rock on">
            🤘
          </span>
          <div className={`${theme.text.primary} font-medium`}>
            {stats.karma} Karma
          </div>
        </div>

        <div className="flex items-center">
          <span className="text-xl mr-2" role="img" aria-label="fire">
            🔥
          </span>
          <div className={`${theme.text.primary} font-medium`}>
            {stats.posts} Posts
          </div>
        </div>

        <div className="flex items-center">
          <span className="text-xl mr-2" role="img" aria-label="writing hand">
            ✍️
          </span>
          <div className={`${theme.text.primary} font-medium`}>
            {stats.comments} comments
          </div>
        </div>
      </div>

      <div className="mt-4">
        <Link to={`/community/profile/${author.id}`}>
          <button className={`btn-sm w-full ${theme.bg.primary} ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 ${theme.text.secondary}`}>
            View Profile
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AuthorInfo;
